
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shoptheroom/shop-the-room-details",
      function () {
        return require("private-next-pages/shoptheroom/shop-the-room-details.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shoptheroom/shop-the-room-details"])
      });
    }
  